import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "visualiser-controls-toggle" }
const _hoisted_2 = ["onClick"]

import {computed} from 'vue';
import {useStore} from '../store';
import {IndoorOutdoor} from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ControlIndoor',
  setup(__props) {

const store = useStore();

const options = computed(() => [
    {value: IndoorOutdoor.Outdoor, label: 'Outdoor'},
    {value: IndoorOutdoor.Indoor, label: 'Indoor'},
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, ({value, label}) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['visualiser-controls-toggle-option', _unref(store).indoorOutdoor === value && 'active']),
        onClick: ($event: any) => (_unref(store).indoorOutdoor = value)
      }, _toDisplayString(label), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}
}

})